import React, { Component } from 'react';
import UrlConstants from '../../constants/UrlConstants';
import { Dispatch } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from '@mui/material';
import { List as ImmutableList } from 'immutable';
import { RootState } from '../../setup';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@mui/styles';
import IMenuItem from '../../interfaces/common/menuItem';
import MainLayout from '../common/widgets/mainLayout';
import PageUtils from '../../utils/pageUtils';
import { Theme } from '@mui/material';
import { ObjectType } from '../../constants/constants';
import Paging from '../../interfaces/common/paging';
import LanguageUtils from '../../utils/LanguageUtils';
import { GridSortModel, GridSortDirection, GridSortItem, GridColumnVisibilityModel } from '@mui/x-data-grid';
import { fetchProductArenaById, getProductArena, isLoadingProductArenas, resetProductArena } from '../../reducers/productArenaReducer';
import ProductArena from '../../interfaces/output/productArena';
import ViewProductArena from './viewProductArena';

interface IProductArenaDetailsProps {
    classes: any;
    theme: Theme;
    fetchProductArenaById: any;
    productArena: ProductArena;
    match: any;
    history: any;
    location: any;
    isLoadingProductArena: boolean;
    resetProductArena: () => void;
}

interface IProductArenaDetailsState {
    productArena: ProductArena;
    menuItems: ImmutableList<IMenuItem>;
    selectedRow?: number;
    serverProductPagination: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchProductArenaById: (terminalId: any) => dispatch(fetchProductArenaById(terminalId)),
    resetProductArena: () => dispatch(resetProductArena())
});

const messages = {
    edit: LanguageUtils.createMessage('Edit'),
    properties: LanguageUtils.createMessage('Properties'),
    productArena: LanguageUtils.createMessage('Product Arena')
};

const mapStoreToProps = (store: RootState) => {
    return {
        productArena: getProductArena(store),
        isLoading: isLoadingProductArenas(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        padding: theme.spacing(4)
    },
    link: {
        textDecoration: 'none',
        color: `${theme.palette.info.main}!important`,
        fontSize: '12px!important'
    }
});

class ProductArenaDetails extends Component<IProductArenaDetailsProps, IProductArenaDetailsState> {
    constructor(props: IProductArenaDetailsProps) {
        super(props);

        this.state = {
            productArena: {} as ProductArena,
            menuItems: ImmutableList([{
                id: 1,
                name: messages.properties,
                icon: <FontAwesomeIcon icon="info-circle" size="1x" transform="grow-4" />,
                additionalMargin: true,
                url: `/${UrlConstants.PRODUCT_ARENAS}/${props.match.params.productArenaId}/properties`,
                isSelected: PageUtils.isPageSelected(`/${UrlConstants.PRODUCT_ARENAS}/${props.match.params.productArenaId}/properties`, props.location.pathname)
            }
            ]),
            serverProductPagination: PageUtils.getDefaultPaging(),
            selectedRow: undefined,
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {

            }
        };
    }

    componentDidMount() {
        const { fetchProductArenaById } = this.props;
        const { productArenaId } = this.props.match.params;

        fetchProductArenaById(productArenaId);
    }

    componentDidUpdate(prevProps: IProductArenaDetailsProps) {
        const { productArena } = this.props;

        if(productArena !== prevProps.productArena) {
            this.setState({ productArena });
        }

        if(prevProps.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
            const menuItems = this.state.menuItems.map((menuItem: IMenuItem) => {
                menuItem.isSelected = PageUtils.isPageSelected(menuItem.url, this.props.location.pathname);

                return menuItem;
            });

            this.setState({
                menuItems: menuItems,
                selectedRow: undefined
            });
        }
    }

    componentWillUnmount() {
        resetProductArena();
    }

    getSelectedMenuItem = (state: IProductArenaDetailsState) => state.menuItems.find(item => item.isSelected);

    handleMenuItems = () => {
        const { menuItems } = this.state;
        const selectedMenuItem = menuItems.find((item: IMenuItem) => item.isSelected);
        const selectedMenuItemId = selectedMenuItem?.id;
        const { productArenaId } = this.props.match.params;

        switch (selectedMenuItemId) {
            case 1: { //details
                return [
                    {
                        href: `${UrlConstants.PRODUCT_ARENAS}/${productArenaId}/edit`,
                        icon: 'edit',
                        text: messages.edit
                    }
                ];
            }

            default: {
                return [];
            }
        }
    }

    render() {
        const { classes, isLoadingProductArena } = this.props;
        const { productArena, menuItems } = this.state;

        return (
            <MainLayout actions={this.handleMenuItems()}
                isLoading={isLoadingProductArena}
                menuItems={menuItems}
                includeDrawer
                objectType={ObjectType.ProductArena}
                menuItem={{
                    id: 1,
                    subname: messages.productArena,
                    value: productArena?.id,
                    icon: <FontAwesomeIcon icon="file-invoice-dollar" size="1x" />
                } as IMenuItem}
            >
                <Container className={classes.container} maxWidth="xl">
                    <Switch>
                        <Route path={`/${UrlConstants.PRODUCT_ARENAS}/:productArenaId/properties`}>
                            <ViewProductArena productArena={productArena} />
                        </Route>
                    </Switch>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ProductArenaDetails));